import { TrialSummary } from "../../types";
import TrialPracticePanel from "./TrialPracticePanel";
import "./TrialModulesPreview.scss";

// Fixed shapes so the preview looks like a real topic list without exposing any module data.
const PLACEHOLDER_ROWS = [
  { name: 38, done: 72, score: 64 },
  { name: 54, done: 45, score: 81 },
  { name: 46, done: 88, score: 57 },
  { name: 62, done: 30, score: 70 },
  { name: 41, done: 64, score: 49 },
  { name: 58, done: 52, score: 76 },
  { name: 35, done: 18, score: 62 },
  { name: 50, done: 80, score: 85 },
  { name: 44, done: 36, score: 53 },
  { name: 56, done: 60, score: 68 },
  { name: 40, done: 25, score: 74 },
  { name: 52, done: 70, score: 59 },
  { name: 37, done: 42, score: 83 },
  { name: 60, done: 90, score: 66 },
  { name: 45, done: 15, score: 72 },
  { name: 55, done: 58, score: 47 },
  { name: 42, done: 76, score: 79 },
  { name: 59, done: 33, score: 61 },
  { name: 48, done: 66, score: 88 },
  { name: 36, done: 50, score: 55 },
];

const TOP_BAR_BUTTON_COLOURS = ["#ee9d08", "#dc3545", "var(--brand-primary)", "#212529"];

const Bar = ({ width }: { width: number | string }) => (
  <span className="trial-modules-preview__bar" style={{ width: typeof width === "number" ? `${width}%` : width }} />
);

const Progress = ({ value, tone }: { value: number; tone: "accent" | "score" }) => (
  <span className={`trial-modules-preview__progress trial-modules-preview__progress--${tone}`}>
    <span style={{ width: `${value}%` }} />
  </span>
);

/** Trial users see a blurred, data-free outline of the topics table behind their trial actions. */
const TrialModulesPreview = ({
  trial,
  subjectId,
  ended,
}: {
  trial: TrialSummary;
  subjectId: string;
  ended: boolean;
}) => (
  <main className="trial-modules-preview">
    <div className="trial-modules-preview__backdrop" aria-hidden="true">
      <div className="modules-table-panel">
        <div className="table-top-bar">
          <div className="table-top-bar__selection">
            <h2>Topics</h2>
          </div>
          <input
            type="text"
            className="modules-search-input"
            placeholder="Search modules..."
            readOnly
            tabIndex={-1}
          />
          <div className="trial-modules-preview__buttons">
            {TOP_BAR_BUTTON_COLOURS.map((colour) => (
              <span key={colour} className="trial-modules-preview__button" style={{ background: colour }} />
            ))}
          </div>
        </div>

        <div className="modules-table-scroll">
          <table>
            <colgroup>
              <col span={1} style={{ width: "5%" }} />
              <col span={1} style={{ width: "20%" }} />
              <col span={1} style={{ width: "14%" }} />
              <col span={1} style={{ width: "10%" }} />
              <col span={1} style={{ width: "10%" }} />
              <col span={1} style={{ width: "14%" }} />
              <col span={1} style={{ width: "10%" }} />
              <col span={1} style={{ width: "7%" }} />
            </colgroup>
            <thead className="table-titles-wrapper">
              <tr style={{ border: "1px solid rgb(240 240 240)" }}>
                <th></th>
                <th>NAME</th>
                <th>DONE</th>
                <th>CORRECT</th>
                <th>INCORRECT</th>
                <th>SCORE</th>
                <th>STARRED</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {PLACEHOLDER_ROWS.map((row, index) => (
                <tr key={index} className="moduleRow">
                  <td>
                    <span className="trial-modules-preview__checkbox" />
                  </td>
                  <td>
                    <Bar width={row.name} />
                  </td>
                  <td>
                    <Bar width="70%" />
                    <Progress value={row.done} tone="accent" />
                  </td>
                  <td>
                    <Bar width="2rem" />
                  </td>
                  <td>
                    <Bar width="2rem" />
                  </td>
                  <td>
                    <Bar width="2.5rem" />
                    <Progress value={row.score} tone="score" />
                  </td>
                  <td>
                    <Bar width="1.5rem" />
                  </td>
                  <td />
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div className="trial-modules-preview__overlay">
      <TrialPracticePanel trial={trial} subjectId={subjectId} ended={ended} />
    </div>
  </main>
);

export default TrialModulesPreview;
